export default {
  CareplanStep: {
    NextButton: 'Caregiver matching',
  },
  TitleCard: {
    Title: 'Your Care Plan',
    Description: 'A structured, customized plan for your loved one\'s specific needs. Your caregiver knows exactly what\'s expected and when. You\'ll stay in the loop with detailed updates after every visit, ensuring the care provided is consistent and evolves with the needs.',
  },
  HowCallWorks: {
    Title: 'How Our Call Works',
    Description: 'On call, we\'ll build a structured care plan designed for consistent, long-term support.',
    StepAskQuestionsTitle: 'We ask questions',
    StepAskQuestionsDescription: 'We\'ll learn about your loved one\'s needs, schedule preferences, and goals for care.',
    StepListenResponsesTitle: 'We listen to your responses',
    StepListenResponsesDescription: 'We clarify details, priorities, and any concerns to ensure nothing important is missed.',
    StepDiscussOutcomesTitle: 'We discuss the best outcomes',
    StepDiscussOutcomesDescription: 'We walk through care options together and align on what support will work best.',
    StepCraftPlanTitle: 'We craft the best care plan for you',
    StepCraftPlanDescription: 'By the end of the call, you\'ll have a clear, structured care plan tailored to your family.',
  },
  BookCall: {
    Title: 'Book Your Call Now',
    Description: 'To move forward with caregiver matching, please book your short planning call.',
    ContactName: 'Daniel C.',
    ContactRole: 'Care Consultant',
    Availability: 'Available Now',
    SelectDay: 'Select a day*',
    SelectTime: 'Select a time*',
    YourName: 'Your name*',
    YourNamePlaceholder: 'Jane Smith',
    PhoneNumber: 'Phone number*',
    PhoneNumberPlaceholder: '123-456-7890',
    ConfirmCallSlot: 'Confirm Call Slot',
    Today: 'Today',
  },
};
